<template>
  <v-dialog persistent width="90%" v-model="active">
    <v-card class="rounded-sm" elevation="4">
      <v-card-title>
        <div class="text-h6">Evaluación de disciplina operativa</div>
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="closeDialog()"><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-card class="rounded-sm" elevation="4">
                <v-card-title>
                  <div class="text-subtitle-1 font-weight-bold">Información general</div>
                </v-card-title>
                <v-card-text>
                  <InformacionGeneralEvaluacionSection :evaluacion="disciplinaOperativa" />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <ProcedimientosCountersSection :procedimientos="activeProcedimientos" />
            </v-col>
            <v-col>
              <ProcedimientosForm
                :procedimientos="activeProcedimientos"
                @add-procedimiento="addProcedimiento"
                :readonly="readonly"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <TextButton
          v-if="!readonly"
          color="secondary"
          @click="triggerSaveDisciplinaOperativa()"
          :loading="loading"
          :disabled="loading"
          >Guardar evaluación</TextButton
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import InformacionGeneralEvaluacionSection from './evaluacion-desempeño/common/InformacionGeneralEvaluacionSection.vue'
import ProcedimientosForm from './evaluacion-desempeño/disciplina-operativa/forms/ProcedimientosForm.vue'
import ProcedimientosCountersSection from './evaluacion-desempeño/disciplina-operativa/section/ProcedimientosCountersSection.vue'
import UpdateEvaluacionDisciplinaOperativaUseCase from '@/modules/evaluacion-desempeño/application/usecases/UpdateEvaluacionDisciplinaOperativa.usecase'
import UpdateEvaluacionDisciplinaOperativaRepository from '@/modules/evaluacion-desempeño/infrastructure/EvaluacionDisciplinaOperativaApi.repository'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: { InformacionGeneralEvaluacionSection, ProcedimientosForm, ProcedimientosCountersSection, TextButton },

  props: {
    active: {
      type: Boolean,
      default: false,
    },

    disciplinaOperativa: {
      type: Object,
    },

    readonly: {
      type: Boolean,
      default: false,
    },
  },

  async mounted() {
    await this.fetchEstatusProcedimiento()
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    activeProcedimientos() {
      return this.disciplinaOperativa.procedimientos.filter(({ estatus }) => Boolean(estatus))
    },
  },

  methods: {
    ...mapActions('disciplinaOperativa', ['updateDisciplinaOperativa']),
    ...mapActions('estatusProcedimiento', ['fetchEstatusProcedimiento']),

    closeDialog() {
      this.loading = false
      this.$emit('close')
    },

    async triggerSaveDisciplinaOperativa() {
      this.loading = true

      await new UpdateEvaluacionDisciplinaOperativaUseCase(new UpdateEvaluacionDisciplinaOperativaRepository()).execute(
        this.disciplinaOperativa
      )

      this.closeDialog()
    },

    addProcedimiento(procedimiento) {
      this.disciplinaOperativa.procedimientos.push(procedimiento)
    },
  },
}
</script>

<style scoped>
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep input,
::v-deep textarea {
  color: #e0e0e0 !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-divider {
  border-color: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}
</style>
